module.exports = __webpack_public_path__ + "img/img_dev.5fdb946a.png";